module.exports = __webpack_public_path__ + "static/icon-65c32f21d44a150a41d805f394601dac.png";